<template>
    <div class="form form__time">
        <label
            v-if="name"
            :for="name | toKebabCase"
            :class="[
                'form__time_title',
                seconds ? 'form__time_title--seconds' : ''
            ]"
        ><span v-if="label">{{label | toCapitalize}}</span><span class="asterisk" v-if="required && label">*</span></label>
        <div class="form__time_fields">
            <div class="columns is-variable is-1">
                <div class="column">
                    <div class="form__time_fields_wrapper">
                        <input
                            type="text"
                            class="form__text_wrapper_input"
                            :placeholder="placeholder"
                            :disabled="disabled"
                            :id="name | toKebabCase"
                            :name="name | toKebabCase"
                            :data-vv-as="dataVvAs"
                            :value="temporaryValue"
                            @input="updateTime($event.target.value)"
                            v-mask="seconds ? '##:##:##' : '##:##'"
                            v-validate="vValidate"
                            @click="emitFocus"
                            @blur="emitBlur"
                        >
                        <v-icon :name="'clock'"></v-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="form__time_errors">
            <span
                class="form__error form__time_error"
                v-if="errors.first(toKebabCase(name))"
            >{{ errors.first(toKebabCase(name)) }}</span>
        </div>
        <template v-if="$slots.default">
            <div class="form__time_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>

import { toKebabCase } from '@/functions'

export default {
  name: 'form-time',
  data () {
    return {
      temporaryValue: ''
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'From'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidate: {
      default: ''
    },
    seconds: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newValue: {
      get () {
        return this.value
      }
    }
  },
  methods: {
    emitFocus () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.pause()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-focus')
    },
    emitBlur () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.resume()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-blur')
    },
    updateTime: function (value) {
      const prevValue = JSON.parse(JSON.stringify(this.temporaryValue))
      this.temporaryValue = value
      if (this.seconds ? value.length !== 8 : value.length !== 5 || value === prevValue) return
      this.$emit('input', value)
    }
  },
  watch: {
    value (value) {
      if (value) {
        this.temporaryValue = value
      }
    }
  },
  mounted () {
    if (this.value) {
      this.temporaryValue = this.value
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formtime";
</style>
